import { getCourseStatusById } from '@/utils/get-course-status-by-id'

export function useTranscriptStatus() {
  function resolveEffectiveStatus(
    statusId: string
    // selectedSerie: string
    // courseSerie: string
  ) {
    // if (selectedSerie === '') return getCourseStatusById(statusId || '')

    // if (Number(courseSerie) <= Number(selectedSerie)) {
    //   if (statusId === COURSE_STATUS.NOT_GRANT.id)
    //     return COURSE_STATUS.ADAPTATION.label
    // }

    return getCourseStatusById(statusId || '')
  }

  return { actions: { resolveEffectiveStatus } }
}
